export default {
  SettingBaseDataLov: {
    valueSet: 'Value Set',
    name: 'Name',
    code: 'Code',

    table: {
      name: 'Name',
      code: 'Code',
      sort: 'Sorting',
      basicInformation: 'Account Information',
      add: 'Create',
      edit: 'Edit',
      nameText: 'Please Enter Name',
      codeText: 'Please Enter Code',
    }
  }
};
